<template>
  <div class="container">
    <h5>您当前所在位置： 首页 >> 通知公告</h5>

    <div class="gonggao-con">
      <h3>通知公告</h3>
      <hr>

  <div class="tzggMore">
       <ul>
        <li v-for="(item,i) in ggList" :key="i" @click="$router.push({path:'/gg',query: {noticeid:item.TZID,fid:item.FID}})">
          <a href="javascript:;">
            <span class="ttl">{{item.TZBT}}</span>
            <span class="dates">{{item.TO_CHAR}}</span>
          </a>
        </li>

        
      </ul>

      <div class="pags">
        <div class="zuo">
          <div class="zuoa" @click="fanye('a')">←←</div>
          <div class="zuob" @click="fanye('b')">←</div>
        </div>
          
          <div class="zhong">
            第<input type="text" v-model="pag" @keyup.enter="toP"> 页 共{{Math.ceil(total/10)}}页
          </div>

        <div class="you">
          <div class="youa" @click="fanye('c')">→</div>
          <div class="youb" @click="fanye('d')">→→</div>
        </div>
          
        </div>

  </div>
     
    </div>
  </div>
</template>


<script>
export default {
  data(){
    return{
      ggList:[],
      //公告总数
      total:0,
      //页码
      pageNum:1,
      //每页多少条
      pageSize:10,

      //输入框双向绑定的数
      pag:1
    }
  },
  methods:{
    //打开加载所有公告列表
    getInfoList(){
      this.post({
          url: 'informMore',
          data:{
            pageNum:this.pageNum,
            pageSize:this.pageSize
          }
      }, (res) => {
        console.log(res);
        if(res.code===200){
          this.ggList=res.data.list
          this.total=res.data.total
        }
      
      })
    },

    fanye(Y){
      if(Y=='a'){
        this.pageNum=1
      }else if(Y=='b'){
        if(this.pageNum==1) return
        this.pageNum--
      }else if(Y=='c'){
        if(this.pageNum==Math.ceil((this.total)/10)) return
        this.pageNum++
      }else if(Y=='d'){
        this.pageNum=Math.ceil(this.total/10)
      }
      this.getInfoList()
    },

    //敲下enter
    toP(){
      if(this.pag>0 && this.pag<=Math.ceil((this.total)/10)){
        this.pageNum=this.pag
        this.getInfoList()
      }else{
        return this.$message.warning('请输入正确的页码');
      }
      
    }
  },
  created(){
    this.getInfoList()
  }
}
</script>


<style scoped>
li{
  list-style: none;
}
.container{
    width: 1000px;
    margin: 0 auto;
    min-height: 100px;
    margin-top: 15px;
    margin-bottom: 45px;
    background-color: #e3eeff;
}
h5{
  height: 30px;
  line-height: 30px;
  border-bottom: 2px solid #c00000;
  font-size: 14px;
  color: #6e6e6e;
  padding-left: 20px;
}
.gonggao-con{
    padding: 0 20px;
    position: relative;
}
h3{
  font-size: 20px;
    color: #000;
    text-align: center;
    height: 80px;
    line-height: 110px;
}
.tzggMore{
  padding-bottom: 80px;
}
.tzggMore ul li{
    border-bottom: 1px dashed #797979;
    height: 47px;
    position: relative;
    cursor: pointer;
    line-height: 65px;
}

.ttl{
    width: 600px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    font-size: 16px;
    color: #000;
}
.dates{
    color: #939393;
    position: absolute;
    right: 0;
    font-size: 16px;
    color: #939393;
}
.ant-pagination{
  margin-left: 382px;
  margin-top: 20px;
}

.pags{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 50px;
}

.pags div{
  margin-left: 10px;
  float: left;
}

.you div,
.zuo div{
  margin-left: 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.zhong input{
    width: 60px;
    height: 22px;
    border: solid 1px #cfd1d9;
    margin: 0 20px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/sy/pages/gdgg.vue